import {DocumentFormProps} from "./DocumentForm";
import {FieldInput} from "@kroschke/react-ui";

function DocumentFormReceiver({
                                  disabled,
                                  value,
                                  onBlur,
                                  validation,
                                  onChange
                              }: DocumentFormProps) {
    return <>
        <div className={'columns'}>
            <div className={'column is-half'}>
                <FieldInput
                    disabled={disabled}
                    label={"Adresszeile 1"}
                    value={value.receiverNamePrimary || ''}
                    help={validation.receiverNamePrimary}
                    invalid={Boolean(validation.receiverNamePrimary)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverNamePrimary: v
                        })
                    }}
                />
            </div>
            <div className={'column is-half'}>
                <FieldInput
                    disabled={disabled}
                    label={"Adresszeile 2"}
                    value={value.receiverNameSecondary || ''}
                    help={validation.receiverNameSecondary}
                    invalid={Boolean(validation.receiverNameSecondary)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverNameSecondary: v
                        })
                    }}
                />
            </div>
        </div>
        <div className={'columns'}>
            <div className={'column is-one-third'}>
                <FieldInput
                    disabled={disabled}
                    label={"Straße"}
                    value={value.receiverAddressStreet || ''}
                    help={validation.receiverAddressStreet}
                    invalid={Boolean(validation.receiverAddressStreet)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverAddressStreet: v
                        })
                    }}
                />
            </div>
            <div className={'column is-one-third'}>
                <FieldInput
                    disabled={disabled}
                    label={"Hausnummer"}
                    value={value.receiverAddressHouseNumber || ''}
                    help={validation.receiverAddressHouseNumber}
                    invalid={Boolean(validation.receiverAddressHouseNumber)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverAddressHouseNumber: v
                        })
                    }}
                />
            </div>
            <div className={'column is-one-third'}>
                <FieldInput
                    disabled={disabled}
                    label={"Zusatz"}
                    value={value.receiverAddressAddition || ''}
                    help={validation.receiverAddressAddition}
                    invalid={Boolean(validation.receiverAddressAddition)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverAddressAddition: v
                        })
                    }}
                />
            </div>
        </div>
        <div className={'columns'}>
            <div className={'column is-half'}>
                <FieldInput
                    disabled={disabled}
                    label={"Postleitzahl"}
                    value={value.receiverAddressPostcode || ''}
                    help={validation.receiverAddressPostcode}
                    invalid={Boolean(validation.receiverAddressPostcode)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverAddressPostcode: v
                        })
                    }}
                />
            </div>
            <div className={'column is-half'}>
                <FieldInput
                    disabled={disabled}
                    label={"Stadt"}
                    value={value.receiverAddressCity || ''}
                    help={validation.receiverAddressCity}
                    invalid={Boolean(validation.receiverAddressCity)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={v => {
                        onChange({
                            ...value,
                            receiverAddressCity: v
                        })
                    }}
                />
            </div>
        </div>
    </>
}

export {
    DocumentFormReceiver
}
